var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15108_1740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.35858 6.5291L3.19505 27.7772C3.19505 27.7772 2.70886 31.0899 6.39059 31.4789C10.0723 31.8679 32.5325 34.0136 32.5325 34.0136C32.5325 34.0136 38.828 36.1594 37.278 26.9951C37.278 22.6074 34.7598 4.38338 34.7598 4.38338L5.71325 3.1202C5.71325 3.1202 3.97212 2.96126 4.35858 6.53329V6.5291Z",
    fill: "#2FB44E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3644 2.63134L12.8782 22.3193C12.8782 22.3193 12.392 25.3392 14.719 25.4396C17.0461 25.54 52.5793 28.0705 52.5793 28.0705C52.5793 28.0705 55.0019 28.0705 52.6749 25.5358C50.3478 23.0011 45.3156 18.1282 45.3156 18.1282C45.3156 18.1282 42.7018 15.7901 45.3156 13.0588C47.9293 10.3275 53.2566 4.87326 53.2566 4.87326C53.2566 4.87326 55.6792 2.24235 51.8022 2.24235C47.9252 2.24235 16.4602 0.00041782 16.4602 0.00041782C16.4602 0.00041782 13.3602 -0.0957843 13.3602 2.63134H13.3644Z",
    fill: "#54BA68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 49.9998L1.84086 49.9036L4.35906 6.529C4.35906 6.529 4.64994 4.38327 5.0364 3.3125C3.7773 4.67606 2.71351 4.87265 2.61377 8.57434C2.51404 12.276 0 49.9998 0 49.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7832 25.9238L37.3747 27.095V31.0895C37.3747 31.0895 37.3747 34.8915 32.5336 34.0132C27.1107 30.8929 18.7832 25.9238 18.7832 25.9238Z",
    fill: "#099C49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 16.083L22.7544 12.8665L25.9499 15.8864L33.6957 8.08984L36.405 11.2101L26.0455 21.5414L19.75 16.083Z",
    fill: "#F4FAFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15108_1740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetFlag);
export default __webpack_public_path__ + "static/media/target-flag.d601b001cfae68bc8887d9f0ed3e7955.svg";
export { ForwardRef as ReactComponent };